export default __webpack_public_path__ + "static/media/envelope-disabled.ed4928d5.svg";